import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/vehicle/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/park/vehicle/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/park/vehicle/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/park/vehicle/save', params, options);

export const addCarMonth = (params, options) =>
  request.post('/api/v4ward/car/CarMonth/save', params, options);

export const addCarMonthNew = (params, options) =>
  request.post('/api/v4ward/monthcar/v1/add', params, options);

export const update = (params, options) =>
  request.post('/api/park/vehicle/update', params, options);

export const syncVehicles = (params, options) =>
  request.post('/api/park/vehicle/sync', qs.stringify(params), options);
export const getcarMonthLastEndTime = (params, options) =>
  request.get(
    '/api/v4ward/car/CarMonth/carMonthLastEndTime',
    Object.assign({}, options, { params })
  );

export const saveCarCharge = (params, options) =>
  request.post('/api/v4ward/car/recharge/submit', params, options);

export const queryCarCharge = (params, options) =>
  request.get('/api/v4ward/car/recharge/pay/query', Object.assign({}, options, { params }));

export const getPayMethods = (params, options) =>
  request.get('/api/v4ward/car/recharge/payMethods/query', Object.assign({}, options, { params }));
export const getPaySceneList = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/car/recharge/getPayScene",
    Object.assign({}, options, { params })
  );

  export const carNoChange = (params, options) =>
  request.post('/api/park/vehicle/carNoChange', params, options);